module.exports = __webpack_public_path__ + "img/apple_logo.c0ab9806.svg";